<script setup>
import { onBeforeUnmount, ref, watchEffect } from 'vue';
import { useUserMedia } from '@vueuse/core';
import CheckIcon from '@/Components/Icons/CheckIcon.vue';
import CrossIcon from '@/Components/Icons/CrossIcon.vue';

const video = ref();
const deviceLabel = ref('');
const deviceStatus = ref('');
const isUnmounted = ref(false);

const { stream, enabled, stop, start } = useUserMedia();

watchEffect(() => {
  if (video.value) {
    video.value.srcObject = stream.value;
  }
});

try {
  start().then(async () => {
    if (isUnmounted.value) {
      await stopLiveStream();
      return;
    }
    deviceLabel.value = stream?.value?.getVideoTracks()[0]?.label;
    deviceStatus.value = 'success';
  });
} catch (error) {
  console.error('Device start failed:', error);
  deviceStatus.value = 'fail';
}

onBeforeUnmount(async () => {
  isUnmounted.value = true;
  stop();
});

async function stopLiveStream() {
  await stream?.value.getTracks().forEach((track) => {
    track.stop();
    stream.value.removeTrack(track);
  });
}
</script>

<template>
  <div class="flex flex-col gap-2 text-left">
    <div class="w-full inline-flex justify-between" style="z-index: 0">
      <label class="block text-sm font-medium text-gray-700 mb-1">
        Camera
        <span class="device-label">{{ deviceLabel }}</span>
      </label>
      <span v-if="deviceStatus === 'success'">
        <CheckIcon
          style="background-color: rgb(62 183 166)"
          class="absolute transition right-6 z-10 text-white rounded-full"
        />
      </span>
      <span v-else-if="deviceStatus === 'fail'">
        <CrossIcon class="absolute transition right-6 z-10 bg-red-100 text-red-800 rounded-full" />
      </span>
    </div>
    <div class="rounded-lg relative w-full h-60 overflow-hidden">
      <div class="absolute h-full w-full bottom-8 left-0">
        <video ref="video" muted autoplay class="w-auto" />
      </div>
      <div
        v-if="!enabled"
        class="
          absolute
          bg-gray-700
          top-0
          left-0
          w-full
          h-full
          flex flex-col
          items-center
          text-sm
          justify-center
          z-10
        "
      >
        <span class="flex items-center">
          <svg
            class="animate-spin -ml-1 h-8 w-8"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="#14B8A6"
              stroke-width="4"
            ></circle>
            <path
              class=""
              fill="#14B8A6"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>
